//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SectionWithFilter from '../../components/SectionWithFilter.vue'
import ProvidableDriversSection from '../../pages/main/sections/VehicleProvision/ProvidableDriversSection.vue'

export default {
  name: 'OrganizationCardSectionProvidableDrivers',
  components: {
    SectionWithFilter,
    ProvidableDriversSection
  },
  props: {
    config: {
      type: Object,
      required: true
    },
    objectSrc: {
      type: Object,
      default: null
    }
  },
  data: () => {
    const formId = 'organizationProvidableDrivers'

    return {
      formId: formId,

      filterConfig: {
        filterName: 'ФИЛЬТР ВОДИТЕЛЕЙ',
        filterType: 'vehicleProviderDriver',
        filterFormId: formId,
        filterUnavailable: false
      }
    }
  },
  computed: {
    objectId: function () {
      return this.objectSrc && this.objectSrc.id || null
    }
  },
  watch: {
    objectSrc: {
      handler: function (object) {
        this.onObjectChanged(object)
      },
      immediate: true
    }
  },
  methods: {
    onObjectChanged: function (object) {
      const tabComponent = this.$refs.tabComponent
      if (tabComponent && tabComponent.onUpdate) {
        tabComponent.onUpdate()
      }
    }
  }
}
